const getMenu = async () => {
    try {
        const url = `${import.meta.env.VITE_GET_MENU}?authkey=${import.meta.env.VITE_AUTHKEY}&id=${import.meta.env.VITE_ID_STORE}&index=${import.meta.env.VITE_INDEX_STORE}`
        console.log(url)
        const res = await fetch(url)
        return await res.json()
    } catch (e) {

    }
}

const getLastMenu = async () => {
    try {
        const url = `${import.meta.env.VITE_GET_LAST_MENU}?authkey=${import.meta.env.VITE_AUTHKEY}&id=${import.meta.env.VITE_ID_STORE}&index=${import.meta.env.VITE_INDEX_STORE}`
        const res = await fetch(url)
        return await res.text()
    } catch (e) {

    }
}

const getZipCode = async zipCode => {
    try {
        zipCode = zipCode.replace(/[^\d]+/g, '')
        const url = `${import.meta.env.VITE_GET_ZIP_CODE}=${zipCode}`
        const res = await fetch(url)
        return await res.json()
    } catch (e) {

    }
}

const sendRequest = async requestData => {
    try {
        const url = `${import.meta.env.VITE_SEND_REQUEST}/pedido`
        const res = await fetch(url, {
            method: 'POST',
            body: JSON.stringify(requestData)
        })
        return await res.json()
    } catch (e) {
        return {returnCode: 0, message: e.message}
    }
}

const getDiscountCoupon = async (discountCoupon) => {
    try {
        const url = `${import.meta.env.VITE_GET_COUPON}?authkey=${import.meta.env.VITE_AUTHKEY}&id=${import.meta.env.VITE_ID_STORE}&cupom=${discountCoupon}`
        const res = await fetch(url)
        return await res.json()
    } catch (e) {
        console.error(e.message)
        return {sucesso: false, mensagem: e.message}
    }
}

const setDiscountCoupon = async (discountCoupon) => {
    try {
        const url = `${import.meta.env.VITE_SET_COUPON}?authkey=${import.meta.env.VITE_AUTHKEY}&id=${import.meta.env.VITE_ID_STORE}&cupom=${discountCoupon}`
        const res = await fetch(url)
        return await res.json()
    } catch (e) {

    }
}

const sendLog = async (body, method = 'POST') => {
    try {
        const url = `${import.meta.env.VITE_SEND_REQUEST}/logs`
        const res = await fetch(url, {
            method: method,
            body: body
        })
        return await res.json()
    } catch (e) {

    }
}

const getLog = async id => {
    try {
        const url = `${import.meta.env.VITE_SEND_REQUEST}/logs/?authkey=${import.meta.env.VITE_AUTHKEY}&id=${id}`
        const res = await fetch(url, {
            method: 'GET'
        })
        return await res.json()
    } catch (e) {

    }
}

const getCoordinatesGoogleMaps = async address => {
    try {
        const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=${import.meta.env.VITE_API_KEY_MAPS}`
        const res = await fetch(url)
        const {results, status} = await res.json()
        const {geometry: {location: {lat, lng}}} = results[0]
        return {status, lat, lng}
    } catch (e) {

    }
    return {status: 'ERROR'}
}

const getCoordinatesLocationIQ = async address => {
    try {
        const url = `https://us1.locationiq.com/v1/search?key=${import.meta.env.VITE_API_KEY_LOCATION_IQ}&q=${address}&format=json&`
        const res = await fetch(url)
        const results = await res.json()
        const {lat, lon} = results[0]
        return {status: 'OK', lat: parseFloat(lat), lng: parseFloat(lon)}
    } catch (e) {

    }
    return {status: 'ERROR'}
}

const getCashback = async (cpf, gularisToken) => {
    try {
        const url = `https://app.gularis.com.br/api/v1/consumidores/saldo?cpf=${cpf}`
        const res = await fetch(url, {
            method: 'GET',
            headers: {
                'Token-Loja': `${gularisToken}`,
            }
        })
        return await res.json()
    } catch (e) {

    }
}

const getLogin = async (requestData) => {
    try {
        const url = `${import.meta.env.VITE_SEND_REQUEST}/login/v2`
        const res = await fetch(url, {
            method: 'POST',
            body: JSON.stringify(requestData)
        })
        return await res.json()
    } catch (e) {

    }
}

const getRecoveryPassword = async (requestData) => {
    try {
        const url = `${import.meta.env.VITE_SEND_REQUEST}/login`
        const res = await fetch(url, {
            method: 'POST',
            body: JSON.stringify(requestData)
        })
        return await res.json()
    } catch (e) {

    }
}

const postClient = async (requestData) => {
    try {
        const url = `${import.meta.env.VITE_SEND_REQUEST}/cadastro`
        const res = await fetch(url, {
            method: 'POST',
            body: JSON.stringify(requestData),
            headers: {
                authorization: import.meta.env.VITE_API_KEY_REGISTER
            }
        })
        return await res.json()
    } catch (e) {

    }
}

const putClient = async (requestData) => {
    try {
        const url = `${import.meta.env.VITE_SEND_REQUEST}/cadastro`
        const res = await fetch(url, {
            method: 'PUT',
            body: JSON.stringify(requestData),
            headers: {
                authorization: import.meta.env.VITE_API_KEY_REGISTER
            }
        })
        return await res.json()
    } catch (e) {

    }
}

const putAddress = async (requestData) => {
    try {
        const url = `${import.meta.env.VITE_SEND_REQUEST}/cadastro/enderecos`
        const res = await fetch(url, {
            method: 'PUT',
            body: JSON.stringify(requestData),
            headers: {
                authorization: import.meta.env.VITE_API_KEY_REGISTER
            }
        })
        return await res.json()
    } catch (e) {

    }
}

const postEmail = async (requestData) => {
    try {
        return await new Promise((resolve) => fetch(import.meta.env.VITE_SEND_EMAIL, {
            method: 'POST',
            body: JSON.stringify(requestData)
        }).finally(() => resolve('ok')))
    } catch (e) {

    }
}

const postCode = async (requestData) => {
    try {
        const url = `${import.meta.env.VITE_SEND_REQUEST}/login/redefinir`
        const res = await fetch(url, {
            method: 'POST',
            body: JSON.stringify(requestData)
        })
        return await res.json()
    } catch (e) {

    }
}


export {
    getMenu,
    getLastMenu,
    getZipCode,
    sendRequest,
    getDiscountCoupon,
    setDiscountCoupon,
    getLog,
    sendLog,
    getCoordinatesGoogleMaps,
    getCoordinatesLocationIQ,
    getCashback,
    getLogin,
    getRecoveryPassword,
    postClient,
    putClient,
    putAddress,
    postEmail,
    postCode
}
